import React, { useEffect, useState, useRef, Fragment } from "react"
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import { useReactToPrint } from 'react-to-print';
import DatePicker from "react-datepicker"
import XLSX from 'xlsx'

import FilterPagination from 'pages/parts/FilterPagination'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, formatDate, returnSign } from 'helpers/helpers'
import CustomTooltip from "pages/parts/CustomTooltip";

function Shift() {
	const { t } = useTranslation()
	const { cashbox_id } = useParams()
	const date = new Date()

	const printRef = useRef();

	const [data, setData] = useState([])
	const [activeTab, setActiveTab] = useState('x_report')
	const [showModal, setShowModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [expandedItems, setExpandedItems] = useState({})
	const [activeCashierLogin, setActiveCashierLogin] = useState('')
	const [reports, setReports] = useState([
		{ 'value': 'x_report', 'name': `X ${t('report')}`, 'active': false },
		{ 'value': 'menus', 'name': `${t('menu')}`, 'active': false },
		{ 'value': 'products', 'name': `${t('products')}`, 'active': false },
		{ 'value': 'preparation_places', 'name': `${t('preparation_places')}`, 'active': false },
		{ 'value': 'deleted_products', 'name': `${t('deleted_products')}`, 'active': false },
		{ 'value': 'order_types', 'name': `${t('order_type')}`, 'active': false },
		{ 'value': 'order_sub_types', 'name': `${t('order_types')}`, 'active': false },
		{ 'value': 'payment_types', 'name': `${t('payment_types')}`, 'active': false },
		{ 'value': 'expenses', 'name': `${t('take_money')}`, 'active': false },
		{ 'value': 'incomes', 'name': `${t('put_money')}`, 'active': false },
		{ 'value': 'clients', 'name': `${t('clients')}`, 'active': false },
		{ 'value': 'debtors', 'name': `${t('debtors')}`, 'active': false },
		{ 'value': 'waiters', 'name': `${t('waiters')}`, 'active': false },
		{ 'value': 'waiters_products', 'name': `${t('waiters_products')}`, 'active': false },
		{ 'value': 'cashiers', 'name': `${t('cashiers')}`, 'active': false },
		{ 'value': 'cashiers_x', 'name': `${t('cashiers')} 2`, 'active': false },
		{ 'value': 'ingredients', 'name': `${t('ingredients')}`, 'active': false },
		{ 'value': 'products_ingredients', 'name': `${t('products_ingredients')}`, 'active': false },
	]);
	const [xReportData, setXreportData] = useState({
		"reports": {},
		"x_report": {},
	})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		pos_id: null,
		search: ''
	})
	const [pagination, setPagination] = useState({
		url: `/cashbox/shift/${cashbox_id}`,
		response: null
	})

	async function searchWithFilter() {
		var filterUrl = `/cashbox/shift/${cashbox_id}`
		var urlParams = ""
		checkFilter()

		if (filterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterData.start_date
		if (filterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterData.end_date
		if (filterData.page)
			urlParams += returnSign(urlParams) + 'page=' + filterData.page

		if (`/cashbox/shift/${cashbox_id}${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	async function toggleModalXreport(item) {
		setSelectedItem(item)
		var response = await GET(`/v1/report-x?pos_id=${item.pos_id}&cashbox_id=${item.cashbox_id}&shift_id=${item.id}&type=x_report`, {}, { loader: true })
		if (httpOk(response)) {
			var xReportDataCopy = { ...xReportData }
			var reportsCopy = [...reports]
			xReportDataCopy['x_report'] = response.data

			for (let i = 0; i < response?.data?.reports?.length; i++) {
				for (let j = 0; j < reportsCopy.length; j++) {
					if (reportsCopy[j]['value'] === response?.data?.reports[i]['value']) {
						reportsCopy[j]['active'] = response?.data?.reports[i]['active']
					}
				}
			}

			setReports(reportsCopy)
			setXreportData(xReportDataCopy)
			setActiveTab('x_report')
			setShowModal(true)
		}
	}

	async function toggleCashier(cashier_login) {
		setActiveCashierLogin(prevId => (prevId === cashier_login ? null : cashier_login));
	}

	async function getData(type) {
		var response = await GET(`/v1/report-x?pos_id=${selectedItem.pos_id}&cashbox_id=${selectedItem.cashbox_id}&shift_id=${selectedItem.id}&type=${type}`, {}, { loader: true })
		if (httpOk(response)) {
			var xReportDataCopy = { ...xReportData }

			if (type === 'x_report') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'menus') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'products') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'preparation_places') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'deleted_products') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'order_types') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'order_sub_types') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'payment_types') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'expenses') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'incomes') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'clients') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'debtors') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'waiters') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'waiters_products') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'cashiers') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'cashiers_x') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'ingredients') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}
			if (type === 'products_ingredients') {
				xReportDataCopy[type] = response.data
				setXreportData(xReportDataCopy)
			}

			setActiveTab(type)
		}
	}

	const handlePrint = useReactToPrint({
		content: () => printRef.current,
	});

	async function exportToExcelItems() {
		var filterUrl = `/shift-payments-excel?id=${selectedItem.id}`

		var excelHeaders = [['ID', t('amount'), t('discount')]]
		const response = await GET(filterUrl)

		if (httpOk(response)) {
			for (let i = 0; i < response.data.data.length; i++) {
				var item = response.data.data[i]
				var excelItems = []
				excelItems.push(item.cheque_id)
				excelItems.push(Number(item.amount))
				excelItems.push(Number(item.discount))
				excelHeaders.push(excelItems)
			}

			for (let i = 0; i < response.data.payments.length; i++) {
				var payment = response.data.payments[i]
				var excelPayments = []
				excelPayments.push(payment.name)
				excelPayments.push(Number(payment.amount))
				excelHeaders.push(excelPayments)
			}

			const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
			const wb = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
			XLSX.writeFile(wb, t('payment') + ".xlsx");
		}
	}

	function resetFilter() {
		setFilterData({
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
			page: 0,
		})
	}

	async function checkFilter() {
		if (
			filterData.start_date === null &&
			filterData.end_date === null
		) {
			setFilterDataExist(false)
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page) {
		setFilterData({ ...filterData, 'page': page })
	}

	function returnEntityType(item) {
		var name = ''
		if (item?.counterparty === 'supplier') {
			name = t('supplier')
		}
		if (item?.counterparty === 'employee' || item?.counterparty === 'employee_salary') {
			name = t('employee')
		}
		if (item?.counterparty === 'organization') {
			name = t('organization')
		}
		if (item?.counterparty === 'client') {
			name = t('client')
		}

		return name
	}

	function TreeTable({ data, level = 0, formatMoney }) {
		return (
			<>
				{data?.map((item, index) => (
					<Fragment key={item.product_id}>
						<tr>
							<td className="text-center">
								{!item.parent_id &&
									<span>{index + 1}</span>
								}
							</td>
							<td style={{ 'paddingLeft': `${level * 10 + 10}px` }}
								onClick={(e) => {
									e.stopPropagation(); // Остановить всплытие события клика
									toggleExpand(item.product_id); // Переключить состояние "открыт/закрыт"
								}}>
								{!item.parent_id &&
									<span className={item?.children?.length ? `product-parent` : ''}>{item.name}</span>
								}
								{item.parent_id &&
									<i className={item?.children?.length ? `product-parent` : ''}>{item.name}</i>
								}
							</td>
							<td></td>
							<td className="text-end">{formatMoney(item.total_quantity, 2)}</td>
						</tr>

						{/* Рекурсивный вызов для children */}
						{expandedItems[item.product_id] && item.children && item.children.length > 0 && (
							<TreeTable
								data={item.children}
								level={level + 1}
								formatMoney={formatMoney}
							/>
						)}
					</Fragment>
				))}
			</>
		);
	}

	const toggleExpand = (product_id) => {
		setExpandedItems((prev) => ({
			...prev,
			[product_id]: !prev[product_id], // Переключаем состояние для текущего элемента
		}));
	};

	useEffect(() => {
		searchWithFilter()
	}, [filterData.page]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('shifts')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('period')}</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.start_date ? new Date(filterData.start_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
											<div className="form-group col-md-6">
												<label className="invisible">.</label>
												<div className="calendar-input">
													<DatePicker
														className="form-control"
														dateFormat="dd.MM.yyyy"
														selected={filterData.end_date ? new Date(filterData.end_date) : ''}
														onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
													<i className="uil uil-calendar-alt"></i>
												</div>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => searchWithFilter(false)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button type="button" className="btn btn-outline-primary btn-wide-2"
									onClick={() => searchWithFilter(true)} title={t('EXCEL')}>
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '100px' }}>ID</th>
									<th style={{ 'width': '10%' }} className="td-ellipsis">{t('shift_number')}</th>
									<th style={{ 'width': '15%' }}>{t('cashier')}</th>
									<th style={{ 'width': '40%' }}></th>
									<th style={{ 'width': '10%' }} className="text-center td-ellipsis">{t('open_date')}</th>
									<th style={{ 'width': '10%' }} className="text-center td-ellipsis">{t('close_date')}</th>
									<th style={{ 'width': '15%' }} className="text-end">
										<CustomTooltip text={t(`${t('cashbox_balance')} = ${t('cash')} + ${t('terminal')} + ${t('debt_returned')} - ${t('expenses')}`)}>
											{t('cashbox_balance')}
										</CustomTooltip>
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className="bg-on-hover"
										onClick={() => toggleModalXreport(item)}>
										<td>{item.id}</td>
										<td>{item.shift_number}</td>
										<td className="td-ellipsis">{item.cashier_name}</td>
										<td></td>
										<td className="text-center">{formatDate(item.opened_at, 'dd.MM.yy HH:mm')}</td>
										<td className="text-center">{formatDate(item.closed_at, 'dd.MM.yy HH:mm')}</td>
										<td className="text-end">{formatMoney(item.balance)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} centered
				size="lg" backdrop="static"
				onHide={() => setShowModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{t('additional_info')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex gap-3" style={{ 'minHeight': '500px' }}>
						<div id="print" style={{ 'width': '70%', 'lineHeight': '15px' }}>
							{activeTab === 'x_report' &&
								<div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('pos')}</span>
										<span>{xReportData.x_report.pos_name}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('cashbox')}</span>
										<span>{xReportData.x_report.cashbox_name}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('shift')} ID</span>
										<span>{xReportData.x_report.shift_id}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('shift_number')}</span>
										<span>{xReportData.x_report.shift_number}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('cashier')}</span>
										<span>{xReportData.x_report.cashier_name}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('start_of_shift')}</span>
										<span>{formatDate(xReportData.x_report.opened_at, 'dd.MM.yy HH:mm')}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('end_of_shift')}</span>
										<span>{formatDate(xReportData.x_report.closed_at, 'dd.MM.yy HH:mm')}</span>
									</div>
									<hr />
									<div className="d-flex justify-content-between mb-1">
										<span>{t('number_of_checks')} [ {t('hall')} ]</span>
										<span>{xReportData.x_report.count_hall}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('number_of_checks')} [ {t('takeaway')} ]</span>
										<span>{xReportData.x_report.count_takeaway}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<span>{t('number_of_checks')} [ {t('delivery')} ]</span>
										<span>{xReportData.x_report.count_delivery}</span>
									</div>
									<div className="d-flex justify-content-between mb-1">
										<b>{t('number_of_checks')}</b>
										<b>{xReportData.x_report.count_cheques}</b>
									</div>
									{!!xReportData.x_report.count_deleted_cheques &&
										<>
											<div className="d-flex justify-content-between">
												<p>{t('number_of_checks')} [ {t('deleted')} ]</p>
												<p>{xReportData.x_report.count_deleted_cheques}</p>
											</div>
											<div className="d-flex justify-content-between">
												<p>{t('number_of_products')} [ {t('deleted')} ]</p>
												<p>{xReportData.x_report.count_deleted_products} | {formatMoney(xReportData.x_report.count_deleted_products_quantity)}</p>
											</div>
										</>
									}
									{(xReportData && xReportData.x_report?.payments?.length > 0) &&
										<hr />
									}
									<div className="d-flex justify-content-between fz14">
										<span>{t('sales')}</span>
										<span className="text-success">{formatMoney(xReportData.x_report?.sales)}</span>
									</div>
									<div className="d-flex justify-content-between fz14">
										<span>{t('service')}</span>
										<span className="text-success">{formatMoney(xReportData.x_report?.service_percentage_amount)}</span>
									</div>
									<div className="d-flex justify-content-between fz14">
										<span>{t('delivery')}</span>
										<span className="text-success">{formatMoney(xReportData.x_report?.total_delivery_amount)}</span>
									</div>
									<div className="d-flex justify-content-between fz14">
										<b>{t('sales_amount')}</b>
										<b>{formatMoney(xReportData.x_report?.total_sales)}</b>
									</div>
									<div className="ms-2">
										<div className="d-flex justify-content-between d-none">
											<p>{t('change')}</p>
											<p className="text-success">{formatMoney(xReportData.x_report?.total_change)}</p>
										</div>
										<div className="d-flex justify-content-between">
											<p>{t('discount')}</p>
											<p className="text-danger">{formatMoney(xReportData.x_report?.total_discount)}</p>
										</div>
										<div className="d-flex justify-content-between">
											<span>{t('debt')}</span>
											<span className="text-danger">{formatMoney(xReportData.x_report.total_debt_amount)}</span>
										</div>
										{xReportData.x_report.loyalty &&
											<div className="d-flex justify-content-between">
												<span>{t('loyalty')}</span>
												<span>{formatMoney(xReportData.x_report?.loyalty?.amount_out)}</span>
											</div>
										}
										<div className="d-flex justify-content-between">
											<b>
												<CustomTooltip text={t(`${t('total')} = ${t('discount')} + ${t('debt')} + ${t('shortage')} + ${t('agents_bonus')}`)}>
													{t('total')}
												</CustomTooltip>
											</b>
											<b className="text-danger">
												{formatMoney(
													Number(xReportData.x_report.total_discount) +
													Number(xReportData.x_report.total_debt_amount)
												)}
											</b>
										</div>
									</div>
									<div className="d-flex justify-content-between fz14">
										<b>
											<CustomTooltip text={t(`${t('total_checkout')} = ${t('sales_amount')} - ${t('discount')} - ${t('agents_bonus')} - ${t('sold_on_credit')} + ${t('amortization')}`)}>
												{t('total_checkout')}
											</CustomTooltip>
										</b>
										<b>{formatMoney(xReportData.x_report?.total_payments)}</b>
									</div>
									<div className="ms-2">
										{xReportData.x_report.loyalty &&
											<div className="d-flex justify-content-between">
												<span>{t('loyalty')}</span>
												<span>{formatMoney(xReportData.x_report?.loyalty?.amount_in)}</span>
											</div>
										}
										{xReportData.x_report?.payments?.map((item, index) => (
											<div className="d-flex justify-content-between" key={index}>
												<p className="d-flex flex-wrap gap-1">
													{item.transaction_type === 'plus' ?
														<span>&#9660;</span>
														:
														<span>&#9650;</span>
													}
													<span>{item.payment_type_name}</span>
													<span>{item.payment_purpose_name}</span>
												</p>
												{item.transaction_type === 'plus' ?
													<p className="text-success text-nowrap">{formatMoney(item.amount)}</p>
													:
													<p className="text-danger text-nowrap">{formatMoney(item.amount)}</p>
												}
											</div>
										))}
										{!!xReportData.x_report.total_cash &&
											<div className="d-flex justify-content-between">
												<b>{t('total_cash')}</b>
												<b className="text-success">
													{formatMoney(xReportData.x_report.total_cash)}
												</b>
											</div>
										}
										{!!xReportData.x_report.total_bank &&
											<div className="d-flex justify-content-between">
												<b>{t('total_bank')}</b>
												<b className="text-success">
													{formatMoney(xReportData.x_report.total_bank)}
												</b>
											</div>
										}
										{!!xReportData.x_report.total_expense &&
											<div className="d-flex justify-content-between">
												<b>{t('total_expense')}</b>
												<b className="text-danger">
													{formatMoney(xReportData.x_report.total_expense)}
												</b>
											</div>
										}
									</div>
									<hr />
									<b className="d-flex justify-content-between">
										<h5 className="color-00">
											<CustomTooltip text={t(`${t('cashbox_balance')} = ${t('cash')} + ${t('debt_returned')} - ${t('expenses')}`)}>
												{t('cashbox_balance')}
											</CustomTooltip>
										</h5>
										<h5 className="text-no-wrap color-00">
											{formatMoney(xReportData.x_report.balance)}
										</h5>
									</b>
									<div className="d-flex justify-content-between">
										<span>{t('action')}</span>
										<div className="d-flex gap-2">
											<div className="table-action-button table-action-primary-button"
												onClick={handlePrint}>
												<i className="uil-print"></i>
											</div>
											<div className="table-action-button table-action-primary-button"
												onClick={() => exportToExcelItems()}>
												<i className="uil-file-alt"></i>
											</div>
										</div>
									</div>
								</div>
							}
							{activeTab === 'menus' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('menu')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.menus?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end text-nowrap">{formatMoney(item.total_quantity)}</td>
													<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.menus.total_quantity)}</b>
												</td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.menus.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'products' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('menu')}</b></th>
												<th className="text-start"><b>{t('product')}</b></th>
												<th className="text-end text-nowrap"><b>{t('quantity')}</b></th>
												<th className="text-end text-nowrap"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.products?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.menu_name}</td>
													<td className="text-start">{item.name}</td>
													<td className="text-end text-nowrap">{formatMoney(item.total_quantity)}</td>
													<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.products.total_quantity)}</b>
												</td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.products.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'preparation_places' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('preparation_places')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.preparation_places?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.preparation_places.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.preparation_places.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'deleted_products' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<div className="table-responsive" >
										<table className="table table-bordered table-bordered-custom">
											<thead>
												<tr>
													<th className="text-start"
														style={{ 'width': '30%' }}>
														<b>{t('name')}</b>
													</th>
													<th className="text-center"
														style={{ 'width': '20%' }}><b>{t('time')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '10%' }}>
														<b>№</b>
													</th>
													<th className="text-end text-nowrap"
														style={{ 'width': '20%' }}>
														<b>{t('quantity')}</b>
													</th>
													<th className="text-end"
														style={{ 'width': '20%' }}>
														<b>{t('amount')}</b>
													</th>
												</tr>
											</thead>
											<tbody>
												{xReportData['deleted_products']?.data?.map((item, index) => (
													<tr key={index}>
														<td className="text-start td-ellipsis">
															{item.name}
														</td>
														<td className="text-center">
															{formatDate(item.created_at, 'HH:mm')}
														</td>
														<td className="text-end td-ellipsis">
															{item.cheque_number}
														</td>
														<td className="text-end td-ellipsis">
															{item.quantity}
														</td>
														<td className="text-end td-ellipsis">
															{formatMoney(item.total_price)}
														</td>
													</tr>
												))}
											</tbody>
											<tfoot>
												<tr>
													<td><b>{t('total')}</b></td>
													<td></td>
													<td></td>
													<td className="text-end">
														<b>{formatMoney(xReportData.deleted_products.total_quantity)}</b>
													</td>
													<td className="text-end">
														<b>{formatMoney(xReportData.deleted_products.total_amount)}</b>
													</td>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							}
							{activeTab === 'order_types' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('name')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className="text-start">{t('hall')}</td>
												<td className="text-end text-nowrap">{formatMoney(xReportData.order_types.total_count_hall)}</td>
												<td className="text-end text-nowrap">{formatMoney(xReportData.order_types.total_amount_hall)}</td>
											</tr>
											<tr>
												<td className="text-start">{t('takeaway')}</td>
												<td className="text-end text-nowrap">{formatMoney(xReportData.order_types.total_count_takeaway)}</td>
												<td className="text-end text-nowrap">{formatMoney(xReportData.order_types.total_amount_takeaway)}</td>
											</tr>
											<tr>
												<td className="text-start">{t('delivery')}</td>
												<td className="text-end text-nowrap">{formatMoney(xReportData.order_types.total_count_delivery)}</td>
												<td className="text-end text-nowrap">{formatMoney(xReportData.order_types.total_amount_delivery)}</td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.order_types.total_quantity)}</b>
												</td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.order_types.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'order_sub_types' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('name2')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData.order_sub_types?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.order_sub_types?.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.order_sub_types?.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'payment_types' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('name')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData.payment_types?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.payment_types?.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData?.payment_types?.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'expenses' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"
													style={{ 'width': '40%' }}><b>{t('type')}</b>
												</th>
												<th className="text-start"
													style={{ 'width': '20%' }}><b>{t('counterparty')}</b>
												</th>
												<th className="text-start"
													style={{ 'width': '20%' }}><b>{t('note')}</b>
												</th>
												<th className="text-end"
													style={{ 'width': '20%' }}><b>{t('amount')}</b>
												</th>
											</tr>
										</thead>
										<tbody>
											{xReportData['expenses']?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start td-ellipsis">
														{item.name}
													</td>
													<td className="text-start td-ellipsis" title={item.counterparty}>
														{item.counterparty}
													</td>
													<td className="text-start td-ellipsis" title={item.note}>
														{item.note}
													</td>
													<td className="text-end text-nowrap">
														{formatMoney(item.amount)}
													</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td></td>
												<td className="text-end text-nowrap">
													<b>{formatMoney(xReportData.expenses.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'incomes' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"
													style={{ 'width': '50%' }}><b>{t('type')}</b></th>
												<th className="text-start"
													style={{ 'width': '30%' }}><b>{t('counterparty')}</b></th>
												<th className="text-end"
													style={{ 'width': '20%' }}><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData['incomes']?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start td-ellipsis">
														{item.name}
													</td>
													<td className="text-start td-ellipsis">
														{item.counterparty}
													</td>
													<td className="text-end">
														{formatMoney(item.amount)}
													</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.incomes.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'debtors' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom mb-2">
										<thead>
											<tr>
												<th className="text-start"><b>{t('client')}</b></th>
												<th className="text-start"><b>{t('counterparty')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData['debtors']?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-start">{returnEntityType(item)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.debtors.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'clients' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('client')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.clients?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.clients.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.clients.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'waiters' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('waiter')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('service')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.waiters?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_service_amount)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.waiters.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.waiters.total_service_amount)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.waiters.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'waiters_products' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									{xReportData?.waiters_products?.data?.map((waiter, wIndex) => (
										<div className="mb-3" key={wIndex}>
											<table className="table table-bordered table-bordered-custom">
												<thead>
													<tr>
														<th style={{ 'width': '50%' }} className="text-start"><b>{waiter.name}</b></th>
														<th style={{ 'width': '25%' }} className="text-end text-nowrap"><b>{t('quantity')}</b></th>
														<th style={{ 'width': '25%' }} className="text-end text-nowrap"><b>{t('amount')}</b></th>
													</tr>
												</thead>
												<tbody>
													{waiter?.products?.map((item, index) => (
														<tr key={index}>
															<td className="text-start">{item.name}</td>
															<td className="text-end text-nowrap">{formatMoney(item.total_quantity)}</td>
															<td className="text-end text-nowrap">{formatMoney(item.total_amount)}</td>
														</tr>
													))}
												</tbody>
												<tfoot>
													<tr>
														<td><b>{t('total')}</b></td>
														<td className="text-end text-nowrap">
															<b>{formatMoney(waiter.total_quantity)}</b>
														</td>
														<td className="text-end text-nowrap">
															<b>{formatMoney(waiter.total_amount)}</b>
														</td>
													</tr>
												</tfoot>
											</table>
										</div>
									))}
								</div>
							}
							{activeTab === 'cashiers' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('cashier')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
												<th className="text-end"><b>{t('amount')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.cashiers?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-end">{formatMoney(item.total_quantity)}</td>
													<td className="text-end">{formatMoney(item.total_amount)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.cashiers.total_quantity)}</b>
												</td>
												<td className="text-end">
													<b>{formatMoney(xReportData.cashiers.total_amount)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'cashiers_x' &&
								<div className="no-scroll" style={{ 'height': '500px', 'overflow': 'auto' }}>
									{xReportData?.cashiers_x?.map((item, index) => (
										<div key={index}>
											<button
												className={`btn mb-2 w-100 ${activeCashierLogin === item.cashier_login ? 'btn-success' : 'btn-outline-success'}`}
												onClick={() => toggleCashier(item.cashier_login)}>
												{item.cashier_name}
											</button>
											<div
												className={`cashier-info-block ${activeCashierLogin === item.cashier_login ? '' : 'd-none'}`}
												style={{ 'height': 'auto', 'overflow': 'visible' }}>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('pos')}</span>
													<span>{item.pos_name}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('cashbox')}</span>
													<span>{item.cashbox_name}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('shift')} ID</span>
													<span>{item.shift_id}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('shift_number')}</span>
													<span>{item.shift_number}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('cashier')}</span>
													<span>{item.cashier_name}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('start_of_shift')}</span>
													<span>{formatDate(item.opened_at, 'dd.MM.yy HH:mm')}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('end_of_shift')}</span>
													<span>{formatDate(item.closed_at, 'dd.MM.yy HH:mm')}</span>
												</div>
												<hr />
												<div className="d-flex justify-content-between mb-1">
													<span>{t('number_of_checks')} [ {t('hall')} ]</span>
													<span>{item.count_hall}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('number_of_checks')} [ {t('takeaway')} ]</span>
													<span>{item.count_takeaway}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<span>{t('number_of_checks')} [ {t('delivery')} ]</span>
													<span>{item.count_delivery}</span>
												</div>
												<div className="d-flex justify-content-between mb-1">
													<b>{t('number_of_checks')}</b>
													<b>{item.count_cheques}</b>
												</div>
												{!!item.count_deleted_cheques &&
													<>
														<div className="d-flex justify-content-between">
															<p>{t('number_of_checks')} [ {t('deleted')} ]</p>
															<p>{item.count_deleted_cheques}</p>
														</div>
														<div className="d-flex justify-content-between">
															<p>{t('number_of_products')} [ {t('deleted')} ]</p>
															<p>{item.count_deleted_products} | {formatMoney(item.count_deleted_products_quantity)}</p>
														</div>
													</>
												}
												{(item && item?.payments?.length > 0) &&
													<hr />
												}
												<div className="d-flex justify-content-between fz14">
													<span>{t('sales')}</span>
													<span className="text-success">{formatMoney(item?.sales)}</span>
												</div>
												<div className="d-flex justify-content-between fz14">
													<span>{t('service')}</span>
													<span className="text-success">{formatMoney(item?.service_percentage_amount)}</span>
												</div>
												<div className="d-flex justify-content-between fz14">
													<span>{t('delivery')}</span>
													<span className="text-success">{formatMoney(item?.total_delivery_amount)}</span>
												</div>
												<div className="d-flex justify-content-between fz14">
													<b>{t('sales_amount')}</b>
													<b>{formatMoney(item?.total_sales)}</b>
												</div>
												<div className="ms-2">
													<div className="d-flex justify-content-between d-none">
														<p>{t('change')}</p>
														<p className="text-success">{formatMoney(item?.total_change)}</p>
													</div>
													<div className="d-flex justify-content-between">
														<p>{t('discount')}</p>
														<p className="text-danger">{formatMoney(item?.total_discount)}</p>
													</div>
													<div className="d-flex justify-content-between">
														<span>{t('debt')}</span>
														<span className="text-danger">{formatMoney(item.total_debt_amount)}</span>
													</div>
													{item.loyalty &&
														<div className="d-flex justify-content-between">
															<span>{t('loyalty')}</span>
															<span>{formatMoney(item?.loyalty?.amount_out)}</span>
														</div>
													}
													<div className="d-flex justify-content-between">
														<b>
															<CustomTooltip text={t(`${t('total')} = ${t('discount')} + ${t('debt')} + ${t('shortage')} + ${t('agents_bonus')}`)}>
																{t('total')}
															</CustomTooltip>
														</b>
														<b className="text-danger">
															{formatMoney(
																Number(item.total_discount) +
																Number(item.total_debt_amount)
															)}
														</b>
													</div>
												</div>
												<div className="d-flex justify-content-between fz14">
													<b>
														<CustomTooltip text={t(`${t('total_checkout')} = ${t('sales_amount')} - ${t('discount')} - ${t('agents_bonus')} - ${t('sold_on_credit')} + ${t('amortization')}`)}>
															{t('total_checkout')}
														</CustomTooltip>
													</b>
													<b>{formatMoney(item?.total_payments)}</b>
												</div>
												<div className="ms-2">
													{item.loyalty &&
														<div className="d-flex justify-content-between">
															<span>{t('loyalty')}</span>
															<span>{formatMoney(item?.loyalty?.amount_in)}</span>
														</div>
													}
													{item?.payments?.map((item, index) => (
														<div className="d-flex justify-content-between" key={index}>
															<p className="d-flex flex-wrap gap-1">
																{item.transaction_type === 'plus' ?
																	<span>&#9660;</span>
																	:
																	<span>&#9650;</span>
																}
																<span>{item.payment_type_name}</span>
																<span>{item.payment_purpose_name}</span>
															</p>
															{item.transaction_type === 'plus' ?
																<p className="text-success text-nowrap">{formatMoney(item.amount)}</p>
																:
																<p className="text-danger text-nowrap">{formatMoney(item.amount)}</p>
															}
														</div>
													))}
													{!!item.total_cash &&
														<div className="d-flex justify-content-between">
															<b>{t('total_cash')}</b>
															<b className="text-success">
																{formatMoney(item.total_cash)}
															</b>
														</div>
													}
													{!!item.total_bank &&
														<div className="d-flex justify-content-between">
															<b>{t('total_bank')}</b>
															<b className="text-success">
																{formatMoney(item.total_bank)}
															</b>
														</div>
													}
													{!!item.total_expense &&
														<div className="d-flex justify-content-between">
															<b>{t('total_expense')}</b>
															<b className="text-danger">
																{formatMoney(item.total_expense)}
															</b>
														</div>
													}
												</div>
												<hr />
												<b className="d-flex justify-content-between">
													<h5 className="color-00">
														<CustomTooltip text={t(`${t('cashbox_balance')} = ${t('cash')} + ${t('debt_returned')} - ${t('expenses')}`)}>
															{t('cashbox_balance')}
														</CustomTooltip>
													</h5>
													<h5 className="text-no-wrap color-00">
														{formatMoney(item.balance)}
													</h5>
												</b>
											</div>
										</div>
									))}
								</div>
							}
							{activeTab === 'ingredients' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-start"><b>{t('element')}</b></th>
												<th className="text-start"><b>{t('category')}</b></th>
												<th className="text-start"><b>{t('unit')}</b></th>
												<th className="text-end"><b>{t('quantity')}</b></th>
											</tr>
										</thead>
										<tbody>
											{xReportData?.ingredients?.data?.map((item, index) => (
												<tr key={index}>
													<td className="text-start">{item.name}</td>
													<td className="text-start">{item.category_name}</td>
													<td className="text-start">{item.unit_name}</td>
													<td className="text-end">{formatMoney(item.total_quantity, 2)}</td>
												</tr>
											))}
										</tbody>
										<tfoot>
											<tr>
												<td><b>{t('total')}</b></td>
												<td></td>
												<td></td>
												<td className="text-end">
													<b>{formatMoney(xReportData.ingredients.total_quantity, 2)}</b>
												</td>
											</tr>
										</tfoot>
									</table>
								</div>
							}
							{activeTab === 'products_ingredients' &&
								<div style={{ 'height': '500px', 'overflow': 'auto' }}>
									<table className="table table-bordered table-bordered-custom">
										<thead>
											<tr>
												<th className="text-center" style={{ 'minWidth': '33px' }}><b>#</b></th>
												<th className="text-start" style={{ 'width': '40%' }}><b>{t('product')}</b></th>
												<th className="text-start" style={{ 'width': '40%' }}><b></b></th>
												<th className="text-end" style={{ 'width': '20%' }}><b>{t('quantity')}</b></th>
											</tr>
										</thead>
										<tbody>
											<TreeTable
												data={xReportData.products_ingredients.data}
												formatMoney={formatMoney}
											/>
										</tbody>
									</table>
								</div>
							}
						</div>
						<div style={{ 'width': '30%' }}>
							<div className="right" style={{ 'overflow': 'auto' }}>
								{reports.map((item, index) => (
									<div className="d-flex justify-content-between mb-2" key={index}
										style={activeTab === item.value ? { 'borderBottom': '1px solid #000' } : {}}>
										<h6 className="w-75"
											onClick={() => getData(item.value)}>
											{item.name}
										</h6>
									</div>
								))}
							</div>
						</div>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Shift
